
























import { Component, Vue } from 'vue-property-decorator';
import InDevelopment from '@/components/InDevelopment.vue';
import MessageService from '@/services/message';
import Sell from '@/entities/Sell';

@Component({
  components: { InDevelopment },
})
export default class Sells extends Vue {
  messageService = new MessageService();

  messages: Sell[] = null;

  mounted() {
    this.messageService
      .listSells()
      .then((messages: Sell[]) => {
        this.messages = messages;
      });
  }
}
